module.exports = __webpack_public_path__ + "assets/img/hwp.b388ff0e.svg";